// removed by extract-text-webpack-plugin
module.exports = {"langswitch":"langswitch__2QJEc"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/coms/LangSwitcher/styles/main.scss
// module id = 2166
// module chunks = 1